export default __webpack_public_path__ + "static/media/mobile_design.17ca87d1.svg";